import { TextField, Typography } from '@mui/material';
import { Autocomplete } from '@mui/material';
import React from 'react';
import { connect } from 'react-redux';

function CompanyWithAutoComplete({ onChange, value, insurers, ...rest }) {
  const insuresHK = insurers.filter(insurer => insurer.region === 'hk');
  const options = insuresHK?.map(insurer => `${insurer.title['en']} - ${insurer.title['zh-Hant-HK']}`);

  const handleChange = (e, value) => {
    onChange?.(value);
  };
  return (
    <Autocomplete
      onInputChange={handleChange}
      onChange={handleChange}
      value={value}
      options={options}
      getOptionLabel={option => option}
      renderInput={params => <TextField {...params} {...rest.inputProps} />}
      renderOption={(props, option) => (
        <li {...props} key={option}>
          <Typography {...rest.optionProps}>{option}</Typography>
        </li>
      )}
      freeSolo={true}
    />
  );
}

export default connect(state => ({
  insurers: state.insurer.insurers
}))(CompanyWithAutoComplete);
